<template>
  <el-col :span="12">
    <el-card :body-style="{ padding: '5px', height: '700px' }">
      <div>
        <span>Cancer Type:</span>
        <el-select v-model="chooseCancer" placeholder="choose Cancer Type" clearable @change="selectCancer" size="mini">
          <el-option
              v-for="item in datasetName"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <el-button type="text" style="float: right;" @click="remove_son_violin">remove</el-button>
      </div>
      <div>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dataset:</span>
        <el-select v-model="chooseDataset" placeholder="choose Dataset" clearable @change="getTLSData" size="mini">
          <el-option
              v-for="item in dataset_result_list"
              :key="item.datasetID + '---' + item.name"
              :label="item.datasetname + '---' + item.name"
              :value="item.datasetID + '---' + item.name">
          </el-option>
        </el-select>
      </div>
      <div class="RadioBox">
        <el-radio-group v-model="TLS_choose" @change="chooseTLS">
          <el-radio :label="1" border size="mini" class="RadioItem2"><span style="font-size: 14px">B</span></el-radio>
          <el-radio :label="2" border size="mini" class="RadioItem2"><span style="font-size: 14px">CD4T</span></el-radio>
          <el-radio :label="3" border size="mini" class="RadioItem2"><span style="font-size: 14px">CD8T</span></el-radio>
          <el-radio :label="4" border size="mini" class="RadioItem2"><span style="font-size: 14px">CD8Tex</span></el-radio>
          <br/>
          <el-radio :label="5" border size="mini" class="RadioItem2"><span style="font-size: 14px">DC</span></el-radio>
          <el-radio :label="6" border size="mini" class="RadioItem2"><span style="font-size: 14px">Endothelial</span></el-radio>
          <el-radio :label="7" border size="mini" class="RadioItem2"><span style="font-size: 14px">Fibroblasts</span></el-radio>
          <el-radio :label="8" border size="mini" class="RadioItem2"><span style="font-size: 14px">Mast</span></el-radio>
          <br/>
          <el-radio :label="9" border size="mini" class="RadioItem2"><span style="font-size: 14px">Mono.Macro</span></el-radio>
          <el-radio :label="10" border size="mini" class="RadioItem2"><span style="font-size: 14px">Myofibroblasts</span></el-radio>
          <el-radio :label="11" border size="mini" class="RadioItem2"><span style="font-size: 14px">Neutrophils</span></el-radio>
          <el-radio :label="12" border size="mini" class="RadioItem2"><span style="font-size: 14px">NK</span></el-radio>
          <br/>
          <el-radio :label="13" border size="mini" class="RadioItem2"><span style="font-size: 14px">pDC</span></el-radio>
          <el-radio :label="14" border size="mini" class="RadioItem2"><span style="font-size: 14px">Plasma</span></el-radio>
          <el-radio :label="15" border size="mini" class="RadioItem2"><span style="font-size: 14px">TMKI67</span></el-radio>
          <el-radio :label="16" border size="mini" class="RadioItem2"><span style="font-size: 14px">Treg</span></el-radio>
        </el-radio-group>
      </div>
      <div :id="myCardID" style="width: 100%; height: 500px"><!-- Plotly chart will be drawn inside this DIV --></div>
<!--      <img :src=TLS_choose_pic alt="" width="100%" height="500px"/>-->
    </el-card>
  </el-col>
</template>

<script>
// import violin_data from "@/assets/testData/violin_data_json.json"
import Plotly from 'plotly.js-dist-min'
// import img from "@/assets/PanCancer/cancerStateJs";

export default {
  name: 'TLSCardViolin2',
  props:{
    cardID: Number
  },
  data(){
    return{
      datasetName: ['Breast Cancer', 'PDAC', 'SCC', 'Melanoma', 'Prostate Cancer', 'Liver Cancer', 'Ovarian Cancer', 'Glioblastoma',
        'Colorectal Cancer', 'Cervical Cancer', 'Bladder Cancer', 'Brain metastases', 'Lung Cancer', 'Head and neck Cancer'],
      chooseCancer: '',
      dataset_result_list: [],
      chooseDataset: '',
      TLS_choose: 1,
      TLS_type_dic: {
        1: 'B',
        2: 'CD4T',
        3: 'CD8T',
        4: 'CD8Tex',
        5: 'DC',
        6: 'Endothelial',
        7: 'Fibroblasts',
        8: 'Mast',
        9: 'Mono/Macro',
        10: 'Myofibroblasts',
        11: 'Neutrophils',
        12: 'NK',
        13: 'pDC',
        14: 'Plasma',
        15: 'TMKI67',
        16: 'Treg'
      },
      myCardID: '',
      formData: {
        datasetID: '',
        Array:  '',
        type: '',
      },
      TLS_data: [],
      immune_type: [],
      immune_json_data: [],
      selectTypeData: []
    }
  },
  mounted() {
    this.myCardID = 'TLScardData' + this.cardID
    // console.log(this.myCardID)
    // this.$nextTick( () => {
    //   this.plot_violin()
    // })
  },
  methods:{
    remove_son_violin(){
      this.$emit("remove_father", this.cardID);
    },
    selectCancer(){
      let _this = this
      console.log(_this.chooseCancer)
      _this.chooseDataset = ''
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/datasets/' + _this.chooseCancer)
          .then(function (response) {
            // console.log(temp)
            _this.dataset_result_list = response.data
            // console.log(_this.dataset_result_list)
          })
    },
    clearPic(){
      this.TLS_choose = 1
      this.TLS_data = []
      this.immune_json_data = []
      this.plot_violin()
    },
    getTLSData(data){
      let _this = this
      _this.formData.datasetID = data.split("---")[0]
      _this.formData.Array = data.split("---")[1]
      _this.clearPic()
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/TLS/'+ _this.formData.datasetID
          +'/'+ _this.formData.Array)
          .then(function (response){
            _this.TLS_data = response.data

            // console.log(_this.TLS_data)
            _this.getImmuneData()
          })
    },
    getImmuneData(){
      let _this = this
      console.log(_this.formData.datasetID+" "+_this.formData.Array)
      // console.log(resolve,reject)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/immune/'+ _this.formData.datasetID
          +'/'+ _this.formData.Array)
          .then(function (res) {
            _this.immune_json_data = res.data
            for (let i = 0; i < _this.immune_json_data.length; i++) {
              let index = _this.TLS_data.findIndex(item => item.spot === _this.immune_json_data[i].spot)
              _this.immune_json_data[i].tag = _this.TLS_data[index].tag
            }
            _this.chooseTLS()
            // console.log(_this.immune_json_data)
          })
    },
    chooseTLS(){
      // console.log(this.TLS_choose)
      // console.log(this.TLS_type_dic[this.TLS_choose])
      this.plot_violin()
      // this.TLS_choose_pic = this.TLS_pic[[this.TLS_value]][this.TLS_choose-1]
    },
    plot_violin(){
      // console.log(violin_data)
      let TLS_type = this.TLS_type_dic[this.TLS_choose]
      if (this.TLS_data.length !== 0){
        let haveCD4T = Object.prototype.hasOwnProperty.call(this.TLS_data[0], "CD4T")
        if (!haveCD4T && TLS_type === 'CD4T'){
          TLS_type = "CD4Tconv"
        }
        console.log(TLS_type)
      }

      function unpack(jsonArray, key, TLS_tag) {
        let temp_l = []
        for(let i = 0; i < jsonArray.length; i++) {
          // console.log(jsonArray[i]);
          if (jsonArray[i]['tag'] === TLS_tag){
            temp_l.push(jsonArray[i][key])
          }
        }
        return temp_l
      }
      var data = [{
        type: 'violin',
        x: 'Non-TLS group',
        y: unpack(this.immune_json_data, TLS_type, 'No'),
        legendgroup: 'Non-TLS group',
        scalegroup: 'Non-TLS group',
        name: 'Non-TLS group',
        box: {
          visible: true
        },
        line: {
          color: 'blue',
        },
        meanline: {
          visible: true
        }
      }, {
        type: 'violin',
        x: 'TLS group',
        y: unpack(this.immune_json_data, TLS_type, 'Yes'),
        legendgroup: 'TLS group',
        scalegroup: 'TLS group',
        name: 'TLS group',
        box: {
          visible: true
        },
        line: {
          color: 'pink',
        },
        meanline: {
          visible: true
        }
      }]
      var layout = {
        title: this.formData.datasetID+" "+this.formData.Array,
        yaxis: {
          zeroline: false
        },
        violinmode: 'group'
      }
      Plotly.newPlot(this.myCardID, data, layout);
    },
  }
};
</script>

<style scoped>
.RadioBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /*padding: 20px;*/
  padding-left: 20px;
  margin: 20px auto;
}

.RadioItem2 {
  /*display: flex;*/
  width: 140px;
  margin: 0 2px 2px 0;
  /*align-items: center;*/
}
</style>
